import { create } from 'zustand'

import { Actions } from '../reassignConnectionsModal.types'
import { ReassignConnectionsState } from './useReassignConnections.types'
import {
  setAction,
  setSalesReps,
  setSourceUser,
  setTargetUser,
} from './useReassignConnectionsActions'

const initialState = {
  action: Actions.REASSIGN,
  salesReps: [],
  sourceUser: null,
  targetUser: null,
}

const useReassignConnectionsStore = create<ReassignConnectionsState>((set) => ({
  ...initialState,
  setAction: ({ action }) => setAction({ action, set }),
  setSalesReps: ({ salesReps }) => setSalesReps({ salesReps, set }),
  setSourceUser: ({ sourceUser }) => setSourceUser({ sourceUser, set }),
  setTargetUser: ({ targetUser }) => setTargetUser({ targetUser, set }),
  resetStore: () => set(initialState),
}))

export default useReassignConnectionsStore
